export default "__VITE_ASSET__BslZjY3s__"